import { gql } from "@/__generated__/gql";

export const RESEND_INVITE_MUTATION = gql(`
  mutation ResendInvite(
    $dashInviteId: ID!
  ) {
    resendDashInviteMutation(input: {
      dashInviteId: $dashInviteId
    }) {
      errors {
        title
        message
      }
    }
  }
`);
